import * as actionTypes from '../actions/actionTypes'

const initialState = {
  data: {},
  error: null,
}

const initialStatePhoneValidate = {
  data: true,
  error: null,
}

const initialStateEmailValidate = {
  data: false,
  error: null,
}

export const register = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.REGISTER_ACCOUNT_SUCCESS:
      const data = action.payload;
      return { ...state, data };
    case actionTypes.REGISTER_ACCOUNT_ERROR:
      return { ...state, data: [], error: action.payload };
    default:
      return state
  }
}

export const validatePhone = (state = initialStatePhoneValidate, action) => {
  switch (action.type) {
    case actionTypes.VALIDATE_PHONE_SUCCESS:
      const data = action.payload;
      return { ...state, data };
    case actionTypes.VALIDATE_PHONE_ERROR:
      return { ...state, data: null, error: action.payload };
    default:
      return state
  }
}

export const validateEmail = (state = initialStateEmailValidate, action) => {
  switch (action.type) {
    case actionTypes.VALIDATE_EMAIL_PUBLIC_SUCCESSS:
      const data = action.payload;
      return { ...state, data };
    case actionTypes.VALIDATE_EMAIL_PUBLIC_ERROR:
      return { ...state, data: null, error: action.payload };
    default:
      return state
  }
}
